import { render } from "./VotesDoneAnswer.vue?vue&type=template&id=55fbdd75"
import script from "./VotesDoneAnswer.vue?vue&type=script&lang=js"
export * from "./VotesDoneAnswer.vue?vue&type=script&lang=js"

import "./VotesDoneAnswer.vue?vue&type=style&index=0&id=55fbdd75&lang=postcss"
script.render = render

export default script